<!-- 登录页 -->
<template>
  <div class="webcardbindMain">

    <div class="webwrapCardBody" style="max-height:400px; overflow-y:auto; " v-if="trueCode == 1">
      <div class="Hseat"></div>
      <div class="inputForm">
        <div class="telDivCard">
          <i class="iconfont iconiconfontshouji"></i>
          <!-- pswWidth1 -->
          <input class="pswWidth1" type="text" placeholder="请输入卡号" v-model="cardNumber" />
           <i class="iconfont iconscan" style="float: right" @click="scancode"></i>
        </div>
        <div class="telDivCard tel_passworld">
          <i class="iconfont iconsuo"></i>
          <input :type="eysTrue ? 'password' : 'text' " placeholder="电子码或密码8-12位不区分大小写" v-model="cardPwd" class="pswWidth1">
          <i :class="['iconfont', eysTrue ? 'icon-eyeopen' : 'icon-eyeclose']" style="float: right" @click="() => eysTrue = !eysTrue"></i>
        </div>
        <div class="clearBoth"></div>
        <!-- v-if="codeNum >= 3" -->
        <div class="telDivCard">
          <i class="iconfont iconiconfont5"></i>
          <input class="pswWidth" type="text" placeholder="请输入验证码" v-model="imageCode" />
          <img :src="imgUrl" @click="getCode" />
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtnCard" @click="login">确定</div>
      <div class="agremmentCard">
        <p>温馨提示：如果只有密码，无需填写第一个输入框内容</p>
      </div>
    </div>
     
       <div class="center_box_list" v-if="trueCode == 0 ">
        页面加载中... 
      </div>
  </div>
</template>

<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
import '@/assets/stylecss/iconfont.css'
var Base64 = require('js-base64').Base64
export default {
  name: 'login',
  data() {
    return {
      trueCode: '0',
      unionid:'',
      eysTrue: true,     // 密码框 显示小眼睛
      token: 'jjcimpilpgejfeehkdinjlbgabbgchhe',
      sign: '',
      cardNumber: '',
      cardPwd: '',
      code: '',
      scanlinks: '',
      businessid: '',
      imgUrl: '',
      imageCode: '',
      appid: "",
      cardcode: '',
      cardrights: '',         
      codeNum:0,          // 如果大于等于2显示验证码否则不显示  
      channel: '',        // 判断渠道ID
      userId: '',         // 用户编码
      mobile: '',         // 手机号
      busNumber: '',       // 业务编码
      merchantId: '',
      cityLogo: "",   // 城市logo
      displayType: "",   // 账户显示色调
      stateId: '',
      dyUrl: '',  //电影地址
      bhUrl: '',  //百货地址
      jumpUrl: '',  //跳转地址
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    this.cardcode = window.location.href.split('?code')[0].split('2dcode/')[1];
    if (this.cardcode) {
      let card = this.cardcode.toString()

      if(card.includes('a_')){
        this.cardNumber = card.substring(2, 15);
        this.cardPwd = card.substring(15, card.length);
      } else if(card.includes('b_')){
        this.cardNumber = card.substring(2, 15);
        this.cardPwd = card.substring(15, 30);
      } else{
        this.cardNumber = card.substring(0, 11);
        this.cardPwd = card.substring(11, card.length);
      }
      if (card.includes('a_') || card.includes('b_')) {
        const cityMerchantId = localStorage.getItem('cityMerchantId')
        // 判断13号位的卡里面 是不是提货券相关
        let checkNumber = card.substring(6, 8)
        // 赋值业务编码
        this.busNumber = checkNumber;
        // let url06 = `http://www.kangou.cn/2dcode/${card}`
        let url06 = `http://account.kangou.cn/activitycardlogin.html#/?token=jjcimpilpgejfeehkdinjlbgabbgchhe&return_uri=https%3A%2F%2Fmall.kangou.cn%2F%23%2FacyIndex&scanlinks=${card}`
        if(card.includes('a_5019') || card.includes('b_5019')){
          url06 = `http://account.kangou.cn/activitycardlogin.html#/?token=jjcimpilpgejfeehkdinjlbgabbgchhe&return_uri=https%3A%2F%2Fmall.dwfuli.com%2F%23%2FacyIndex&scanlinks=${card}`
        }
        // let url10 = `https://park.kangou.cn/wap.php?g=Wap&c=Danpin&a=company_goodslist&params=${this.cardNumber}${this.cardPwd}`   // 健康卡
        let url10 = `https://park.kangou.cn/wap.php?g=Wap&c=Home&a=codeEnterprise&label=1&cardnum=${this.cardNumber}&password=${this.cardPwd}&userId=${this.userId}&phone=${this.mobile}`   // 工夫公园
        let url11 = `https://park.kangou.cn/wap.php?g=Wap&c=Danpin&a=videoMem&2dcode=${this.cardNumber}${this.cardPwd}`   // 影音卡
        let url14 = `http://account.kangou.cn/giftvoucher.html#/?scanlinks=${card}`
        let url20 = `http://account.kangou.cn/zxwxcardbind.html#/?cardNumber=${this.cardNumber}&cardPwd=${this.cardPwd}&code=${this.getUrlCode().code}`
        let url21 = `http://account.kangou.cn/blindBox.html#/?code=${this.getUrlCode().code}&url=${window.location.href.split('?code')[0]}`
        checkNumber == '06' ? window.location.href = url06 : 
        checkNumber == '10' ? window.location.href = url10 : 
        checkNumber == '11' ? window.location.href = url11 : 
        checkNumber == '14' ? window.location.href = url14 : 
        checkNumber == '15' ? window.location.href = url14 : ''
        checkNumber == '20' ? window.location.href = url20 : ''
        checkNumber == '21' ? window.location.href = url21 : ''
        if((this.getUrlCode().code && checkNumber == '20')||(this.getUrlCode().code && checkNumber == '21')) return false;

      }else{
        // 判断11号位的卡里面 是不是提货券相关 卡号：第一二位是 81，第五位是9
        let checkNumber1 = card.substring(0, 2)
        let checkNumber2 = card.substring(4, 5)
        let url06 = `http://www.kangou.cn/2dcode/${card}`
        if(checkNumber1 == '81' && checkNumber2 == '9'){
          window.location.href = url06;
        }
      }
    }
    this.channel = this.$route.query.channel 
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
    this.getwebAppId()
  },
  mounted () {
     
    //   history.pushState(null, null, location.href);
    //   window.history.forward(1);  // 此行可以兼容 IE
    //   window.addEventListener('popstate', function(event) {
    //       history.pushState(null, null, location.href );
    //       window.history.forward(1);
    //  }); 
    //  this.getwebAppId()
  },
  components: { JmmToast },
  methods: {
          //  1 code地址
    getUrlCode() { // 截取url中的code方法
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
            }
          }
          return theRequest
      },

    // 获取城市appId
    async getwebAppId(){
      try {
        let info = { "card":  this.cardNumber}
        const res = await api.user.getwebAppId(info)
        if (res.code == "000000") {
          this.appid = res.data.appId;
          this.cityLogo = res.data.logo;
          this.displayType = res.data.displayType;
          if(this.cityLogo == null || this.cityLogo == undefined){
            this.cityLogo = "";
          }
          localStorage.setItem('cityLogo', this.cityLogo);
          localStorage.setItem('displayType', this.displayType);
          var merchantIdTemp = res.data.merchantId;
          if(null != merchantIdTemp && undefined != merchantIdTemp && '' != merchantIdTemp){
            localStorage.setItem('cityMerchantId', merchantIdTemp);
            this.merchantId = merchantIdTemp;
          }
          // 电影地址
          this.dyUrl = res.data.dyUrl;
          // 百货地址
          this.bhUrl = res.data.bhUrl;
          // 跳转地址
          this.jumpUrl = res.data.jumpUrl;
          this.getCodeNum();
        } else {
          this.getCodeNum();
        }
      } catch (err) {
        this.getCodeNum();
        console.log(err)
      }      
    },
    // 2 非静默授权，第一次有弹框
    getCodeNum(){ 
      this.code = ''
      var local = window.location.href // 获取页面url
      if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
        // 获取授权后的code位置
        var codeBeg = local.indexOf("?code=");
        var codeEnd = local.indexOf("#/?");
        // 截取授权后的code数据
        var codeCut = local.substring(codeBeg, codeEnd);
        local = local.replace(codeCut, "");
      }
      this.code = this.getUrlCode().code // 截取code
      if (!this.code) { // 如果没有code，则去请求
      // if (this.code == null || this.code == '' || this.code == undefined) { // 如果没有code，则去请求
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}&connect_redirect=1#wechat_redirect`
      } else {
        var merchantIdState = this.getUrlCode().state // 截取state
        if(null == merchantIdState || undefined == merchantIdState){
          merchantIdState = '';
        }
        if('' == this.merchantId && '' != merchantIdState){
          this.merchantId = merchantIdState;
          localStorage.setItem('cityMerchantId', this.merchantId);
        }
        // 通过code获取信息 
        this.fetch(this.code)
      }
  }, 
  //  code 登录
  async fetch(codeNum) {
    try {
      let info = { "appId": this.appid, "wxcode": codeNum }
    
        localStorage.setItem('reToken', this.token)
        const res = await api.user.getwebLogin(info)
        if (res.code == "000000") { 
            this.sign = res.data.sign;
            this.unionid = res.data.unionid;
            //用户编码
            this.userId = res.data.userid;
            //手机号
            this.mobile = res.data.mobile;
            localStorage.setItem('unionid', res.data.unionid)
            localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
            localStorage.setItem('codeSign', res.data.sign)
            this.getCode();
        } else{
          if (res.code == '40163' || res.code == '40029') {
            var local = window.location.href // 获取页面url
            if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
              // 获取授权后的code位置
              var codeBeg = local.indexOf("?code=");
              var codeEnd = local.indexOf("#/?");
              // 截取授权后的code数据
              var codeCut = local.substring(codeBeg, codeEnd);
              local = local.replace(codeCut, "");
            }
            // 重新访问 此路径地址
            window.location.href = local;
          }
        }
    } catch (err) {
      console.log(err)
    }
  },
    // 图形验证码
    async getCode() {
      try {
        localStorage.setItem('reToken', this.token)
        let data = await api.user.getCode(this.sign, 'img')
        this.imgUrl = window.URL.createObjectURL(data)
        
        this.imgUrl ? this.trueCode = 1 : ''

      } catch (err) {
        console.log(err)
      }
    },
    // 点击登录
    async login() {
      let _this = this
      try {

        if (!_this.cardPwd) {
          JmmToast('请输入正确的密码')
          return
        }
        // if(this.codeNum >= 3){
          if (!_this.imageCode) {
            JmmToast('请输入完整的验证码')
            return
          }
        // }
      
        // 执行登陆接口
        let params = {
          sign: _this.sign,
          card: _this.cardNumber,
          pwd: _this.cardPwd,
          isbind: 1,
          scanLinks: '',
          businessid: '10002',
          imageCode: _this.imageCode,
          channel: _this.channel,
          // imageCode: this.codeNum <= 3 ? 0 : _this.imageCode,
        }
        localStorage.setItem('reToken', this.token)
        const res = await api.user.webBindCard(params)
        if (res.code == '000000') {
          let jumpUrl = res.data.jumpUrl;
          if(null != jumpUrl && undefined != jumpUrl && '' != jumpUrl){
            window.location.href = jumpUrl;
            return;
          }
          // 判断工夫公园相关卡号逻辑
          if(_this.busNumber == '10'){
            let hrefUrl = "https://park.kangou.cn/wap.php?g=Wap&c=Home&a=codeEnterprise&label=1&cardnum=" + _this.cardNumber + "&password=" + _this.cardPwd + "&phone=" + _this.mobile + "&userId=" + _this.userId;
            window.location.href = hrefUrl;
            return;
          }
          if (res.data.cardrights) {
            let cardrights = res.data.cardrights;
            console.log(cardrights)
            if(cardrights.includes('4101')){
              let toUrl = `http://www.gonghuidefu.com/brandcoupon?unionid=${_this.unionid}&sessionkey=${localStorage.getItem('reSESSIONKEY')}&cardrights=${cardrights}`;
              window.location.href = toUrl;
            }else if(cardrights.includes('1014')){ //线下美欣蛋糕
              window.location.href = 'http://www.gonghuidefu.com/cakeWelfare/cakeWelfare.html'
            }else{
              // let baihuo = 'https://www.kangou.cn/movie.php?partnername=kangou&mod=malls&menu=1'
              // let dangao = 'http://www.gonghuidefu.com/auth2'
              let dangao = 'https://account.kangou.cn/h5cardloginlist.html#/?channel=WUHANSHOP&merchantId=100007&cardrights=40000,10030&return_url=https://whkg.kangou.cn/djj/dg/gotodg&myorder_url=https://whkg.kangou.cn/djj/dg/getTokens?citySource=100007&myorder_name='

              // let dianY = 'https://www.kangou.cn/index.html'
              if (cardrights.includes('10000')) {
                let baiHuoUrl = encodeURIComponent(this.bhUrl);
                if(null != this.jumpUrl && undefined != this.jumpUrl && "" != this.jumpUrl){
                  baiHuoUrl = encodeURIComponent(this.jumpUrl);
                }
                let toCardListUrl = `https://account.kangou.cn/h5cardloginlist.html#/?merchantId=${this.merchantId}&channel=BAIHUO&cardrights=${cardrights}&return_url=${baiHuoUrl}`
                window.location.href = toCardListUrl; 
              } else if(cardrights.includes('50000')){
                let dianYingUrl = encodeURIComponent(this.dyUrl);
                if(null != this.jumpUrl && undefined != this.jumpUrl && "" != this.jumpUrl){
                  dianYingUrl = encodeURIComponent(this.jumpUrl);
                }
                let toCardListUrl = `https://account.kangou.cn/h5cardloginlist.html#/?merchantId=${this.merchantId}&channel=BAIHUO&cardrights=${cardrights}&return_url=${dianYingUrl}`
                window.location.href = toCardListUrl; 
              } else {
                let dianYingUrl = encodeURIComponent(this.dyUrl);
                if(null != this.jumpUrl && undefined != this.jumpUrl && "" != this.jumpUrl){
                  dianYingUrl = encodeURIComponent(this.jumpUrl);
                }
                let toCardListUrl = `https://account.kangou.cn/h5cardloginlist.html#/?merchantId=${this.merchantId}&channel=&cardrights=${cardrights}&return_url=${dianYingUrl}`
                window.location.href = cardrights.includes('40000') ? dangao : toCardListUrl
              }
            }
          }
        } else {
          // this.codeNum ++;
          // if(this.codeNum >= 3){
          //   this.getCode();
          // }
          JmmToast(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 点击扫码 按钮 打开相机
   async getSigncode() {
      try {
         let that = this
         const url = encodeURIComponent(location.href.split("#")[0]); //获取当前页面路由
        //  let url = location.href.split('#')[0]
         const res = await api.user.getSign(url)
          // console.log(res, ' === getSign返回')
        if (res.code == '000000') {
          wx.config({
            debug: false, 
            appId: that.appid,              // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          })

            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function(res) {
                that.Toscan(res.resultStr)
              },
              fail: function(res) {
                console.log(res)
              }
          });
        }                                                                                                                        
      } catch (error) {
        console.log(error)
        // JmmToast(error)
      }
    },
    
    // 点击二维码获取
    scancode() {
      this.getSigncode()
    },
    // 扫码接口调用
   async Toscan (can) {
      let info = {
          businessid: '10002',
          sign: this.sign,
          scanLinks:Base64.encode(can),
          isbind: 1,
          card: '',
          pwd: '',
          channel: this.channel,
      }
      localStorage.setItem('reToken', this.token)
      const res = await api.user.cardBindScanLinks(info)
      
      if (res.code == '000000') {
        
        // window.location.href = this.channel ? toUrl1 : toUrl2
         
      } else {
        JmmToast(res.message)
      }
      
   }
   
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.tel_passworld img{
  width: 15px; 
  vertical-align: middle;
  float: right;
}

.webcardbindMain
  width 100%
  height 100%
  overflow hidden
  background #fff
.webcardbindMain .webcardloginHead
  width 100%
  height 50px
  line-height 50px
  text-align center
.webcardbindMain .webcardloginHead .headleft
  float left
  text-align left
  width 70%
  font-size 30px
  height 50px
.webcardbindMain .webcardloginHead .headright
  float right
  text-align right
  width 30%
  font-size 30px
  height 50px
.webwrapCardBody
  width 100%
  height 100%
.webwrapCardBody .Hseat
  height 60px
.webwrapCardBody .telDivCard
  width calc(100% - 150px)
  margin 15px auto
  height 110px
  border-bottom 1px solid #ddd
  i
    font-style normal
    margin-top 30px
    float left
    vertical-align middle
  input
    height 80px
    font-size 45px
    margin-left 20px
    border none
    vertical-align middle
  button
    border 2px solid $codeColor
    width 180px
    height 66px
    font-size 28px
    background $codeColor
    color black
    float right
  img
    width 30% !important
    height 45px !important
    display inline-block
    vertical-align middle
  .pswWidth
    font-size 32px;
    width 50% !important
    display inline
  .pswWidth1
    font-size 32px;
    width 80% !important
    display inline
.loginBtnCard
  width calc(100% - 150px)
  height 90px
  line-height 90px
  margin 0 auto
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color $color
.agremmentCard
  width calc(100% - 224px)
  margin 32px auto
  font-size 24px
.clearBoth
  clear both
.leftRouter
  float $floLeft
.rightRouter
  float $florRight
.card
  background #fff
  height 100%
input::-webkit-input-placeholder /* WebKit browsers */
  font-size 28px
  line-height normal
input::-moz-input-placeholder /* Mozilla Firefox */
  font-size 28px
  line-height normal
input::-ms-input-placeholder /* Internet Explorer */
  font-size 28px
  line-height normal

  .codeLogin_sao {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.3;
  }


.center_box_list {
  font-size: 28px;
  font-family: Source Han Sans SC VF;
  text-align: center;
	border-radius: 20px;
	width: 80%;
	height: 350px;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/wxcardbind/index.vue